module Meevo.Components.Busy {

  export class BusyService implements IBusyService {

    constructor(private $rootScope: ng.IRootScopeService) {

    }

    /**
    * Emits a message to request that the global busy visual appear.
    * messageKey is an optional parameter if the consumer wants to override the text that shows next to the busy indicator.
    */
    start(messageKey?: string, highVisibility?: boolean, withTimeout: boolean = false) {
        this.$rootScope.$emit(Meevo.Components.Common.Messages.GLOBAL_BUSY_START, messageKey, highVisibility, withTimeout);
    }

     /**
    * Emits a message to request that the global busy visual hide.
    * messageKey is an optional parameter if the consumer wants to override the text that shows next to the busy indicator.
    */
    stop(withTimeout: boolean = false) {
      this.$rootScope.$emit(Meevo.Components.Common.Messages.GLOBAL_BUSY_STOP, withTimeout);
    }

    public setProgress(percent: number): void {
      this.$rootScope.$emit(Meevo.Components.Common.Messages.GLOBAL_BUSY_PROGRESS, percent);
    }

    static factory(): Function {
      let svc = ($rootScope: ng.IRootScopeService) => {
        return new BusyService($rootScope);
      }

      svc.$inject = ['$rootScope'];
      return svc;
    }

  }

  angular.module("meevo")
    .factory("meevo.components.busy.BusyService", BusyService.factory());
}
